document.addEventListener('DOMContentLoaded', () => {
  const contentArea = document.querySelector('[data-program-content-area]');
  const contentList = document.querySelectorAll('[data-program-content-title]');

  if (!contentArea) return;

  const getTitleByContentId = (id) => {
    return Array.from(contentList).find((item) => item.getAttribute('data-program-content-title') === id);
  }

  const hideAllContents = () => {
    contentArea.querySelectorAll('[data-program-content]').forEach((content) => {
      content.classList.add('tw-hidden');
    });
  };

  const deactivateContentList = () => {
    contentList.forEach((item) => {
      item.classList.remove('active');
    });
  }

  const showContentById = (id) => {
    const targetContent = contentArea.querySelector(`[data-program-content="${id}"]`);
    if (!targetContent) return;
    hideAllContents();
    deactivateContentList();
    const wrapper = targetContent;
    if (wrapper) {
      wrapper.classList.remove('tw-hidden');
      contentArea.scroll({
        top: 0,
      });

      // activate corresponding title
      const titleEl = getTitleByContentId(id);

      if (!titleEl) return;

      titleEl.classList.add('active');
    }
  };

  if (contentArea.children.length) {
    hideAllContents();
    const first = contentArea.children[0];
    if (first) {
      first.classList.remove('tw-hidden');
      const firstTitle = getTitleByContentId(first.getAttribute('data-program-content'));

      if (!firstTitle) return;

      firstTitle.classList.add('active');
    }
  }

  document.addEventListener('click', (e) => {
    const titleEl = e.target.closest('[data-program-content-title]');
    if (titleEl) {
      const id = titleEl.getAttribute('data-program-content-title');
      showContentById(id);
      return;
    }

    const nextBtn = e.target.closest('[data-next-program-control]');
    if (nextBtn) {
      const nextId = nextBtn.getAttribute('data-next-program-control');
      showContentById(nextId);
    }
  });
});
